import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { RECALLS_FOLLOWUPS_PAUSED } from "@/config/recall-followup-availability";

export function RecallFollowUpRoute({ children }: { children: ReactNode }) {
  if (RECALLS_FOLLOWUPS_PAUSED) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
